import React from 'react'

import fullscreen from './../../../UI/canvas/TopMenu/fullscreen.svg'
import volume from './../../../UI/canvas/TopMenu/volume.svg'
import volumeOff from './../../../UI/canvas/TopMenu/SonidoOFF.svg'
import tuto from './../../../UI/canvas/TopMenu/tuto.svg'
import test from './../../../UI/canvas/TopMenu/testdrive.svg'
import compra from './../../../UI/canvas/TopMenu/compra.svg'
import cotiza from './../../../UI/canvas/TopMenu/cotiza.svg'
import star from './../../../UI/canvas/TopMenu/Star.svg'

import song from './../../../assets/song/song.mp3'

interface Props{
    handleFullScreen: any
    handleAudio: any,
    isMuted: any,
    handleOpenSurvey: any
}

interface State{
    isMuted: boolean
}

declare const window: any;

class TopMenu extends React.Component<Props,State>{
    constructor(props: Props){
        super(props);
        this.state = {
            isMuted: true
        }
    }

    componentDidMount(){
        var audio = document.getElementById("song")
    }

    render(): React.ReactNode {
        return(
            <div className='top-menu'>
                <div className='top-menu-btn fullscreen-btn' onClick={this.props.handleFullScreen}>
                    <img src={fullscreen}/>
                </div>

                <div className='top-menu-btn volume-btn' onClick={() => {this.props.handleAudio()}}>
                    <img src={this.props.isMuted ? volumeOff: volume}/>
                </div>

                <a href='https://www.ford.com.co/politica-tratamiento-datos/' target={"_blank"}>
                    <div className='top-menu-btn tuto-btn'>
                        <img src={tuto}/>
                    </div>
                </a>

                {/*<div className='top-menu-btn-alt survey-btn' onClick={() => {
                    window.paramsObj = {
                        "section-menus": "GENERAL"+">"+"CALIFICACIÓN",
                                };
                    window.ym(88905571, "params", window.paramsObj || {})
                    this.props.handleOpenSurvey(true)
                }}>
                        <img src={star}/>
                        <div>¡Califícanos!</div>
            </div>*/}

                <a 
                    href={"https://www.ford.com.co/test-drive/?&leadsource=VS"}
                    target={"_blank"}
                    onClick = {
                        () => {
                            window.paramsObj = {
                                "section-menus": "GENERAL"+">"+"TEST DRIVE",
                                        };
                            window.ym(88905571, "params", window.paramsObj || {})
                        }
                    }
                    id='element-umbra-analytics' data-value={"Test drive"} data-type={"INTERFAZ"}
                >
                    <div id='element-umbra-analytics' data-value={"Test drive"} data-type={"INTERFAZ"} className='top-menu-btn-alt test-btn'>
                        <img id='element-umbra-analytics' data-value={"Test drive"} data-type={"INTERFAZ"} src={test}/>
                        <div id='element-umbra-analytics' data-value={"Test drive"} data-type={"INTERFAZ"} className='top-menu-text'>
                            Test drive
                        </div>
                    </div>
                </a>

                {/* <a 
                    href={"https://www.ford.com.co/compra/?&leadsource=VS"}
                    target="_blank"
                    onClick = {
                        () => {
                            window.paramsObj = {
                                "section-menus": "GENERAL"+">"+"COMPRA REMOTA",
                                        };
                            window.ym(88905571, "params", window.paramsObj || {})
                        }
                    }
                    id='element-umbra-analytics' data-value={"Compra remota"} data-type={"INTERFAZ"}
                >
                <div id='element-umbra-analytics' data-value={"Compra remota"} data-type={"INTERFAZ"} className='top-menu-btn-alt compra-btn'>
                    <img id='element-umbra-analytics' data-value={"Compra remota"} data-type={"INTERFAZ"} src={compra}/>
                    <div id='element-umbra-analytics' data-value={"Compra remota"} data-type={"INTERFAZ"} className='top-menu-text'>
                        Compra remota
                    </div>
                </div>
                </a> */}
                <a 
                    href={"https://www.ford.com.co/cotiza/?&leadsource=VS"}
                    target="_blank"
                    onClick = {
                        () => {
                            window.paramsObj = {
                                "section-menus": "GENERAL"+">"+"COTIZADOR",
                                        };
                            window.ym(88905571, "params", window.paramsObj || {})
                        }
                    }
                    id='element-umbra-analytics' data-value={"Cotiza"} data-type={"INTERFAZ"}
                >

                    <div id='element-umbra-analytics' data-value={"Cotiza"} data-type={"INTERFAZ"} className='top-menu-btn-alt cotiza-btn'>
                        <img id='element-umbra-analytics' data-value={"Cotiza"} data-type={"INTERFAZ"} src={cotiza}/>
                        <div id='element-umbra-analytics' data-value={"Cotiza"} data-type={"INTERFAZ"} className='top-menu-text'>
                            Cotiza
                        </div>
                    </div>
                </a>
            </div>
        )
    }
}

export default TopMenu